<template>
  <div>
    <el-dialog title="菜单设置" :visible.sync="dialogMenu.show" width="30%" @opened="opened()" :modal="false">
      <div style="height:300px;" id="menu">
        <el-scrollbar style="height:100%">
          <form id="menuForm">
            <div v-for="item in menu">
              <div class="menu_pare">{{ item.name }}</div>
              <el-row v-for="child in item.childList" :key="child.code">
                <el-col class="menu">
                  &nbsp;&nbsp;&nbsp;{{ child.name }}
                </el-col>
                <el-row v-for="sensor in child.childList" :key="sensor.code">
                  <el-col :span="12">
                    <input type="checkbox" v-model="menuChecked" :value="sensor.code" :id="'sensor'+sensor.code"
                           @change="setSensor(sensor.code)"><label
                    :for="'sensor'+sensor.code">{{ sensor.name }}</label>
                  </el-col>
                  <el-col :span="12" v-if="sensor.sensorAlgorithmOldList!=0">
                    <select @change="setAlg(sensor.code)" :id="'algo'+sensor.code" disabled="false">
                      <option value="-1">请选择传感器算法</option>
                      <option v-for="alg in sensor.sensorAlgorithmOldList" :key="alg.id" :value="alg.id">
                        {{ alg.sensorName }}
                      </option>
                    </select>
                  </el-col>
                </el-row>
              </el-row>
            </div>
          </form>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="closeDialog()">取消</el-button>
                    <el-button type="primary" @click="saveMenus()">确定</el-button>
                </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name:"menuSelect",
  props: {
    dialogMenu: Object,
    menu: {
      Type: Array,
      default: () => []
    },
    chosed: {
      Type: Array,
      default: () => []
    }
  },
  data() {
    return {
      menuChecked: [],//菜单的复选框cc
      senorOption: '',//无用数据 -
      menusData: [], //保存数据集合
      token: '',//无用数据 -
      options: {}//无用数据 -
    }
  },
  mounted: function () {

  },
  methods: {
    setAlg(code) {
      let id = $("#algo" + code).val();
      let index = this.menusData.findIndex((menu) => {
        if (menu.objectId === code) {
          return true;
        }
      });
      this.menusData[index].algorithmId = id;
    },
    setSensor(code) {
      if (!$("#algo" + code)) {
        return;
      }
      if ($("#sensor" + code).prop("checked")) {
        $("#algo" + code).attr("disabled", false);
        //组装json
        this.menusData.push({
          objectId: code,
          childProjectId: this.dialogMenu.childProjectId,
        });

      } else {
        $("#algo" + code).attr("disabled", true);
        let index = this.menusData.findIndex((menu) => {
          if (menu.objectId === code) {
            $("#algo" + code).val(-1);
            return true;
          }
        });
        this.menusData.splice(index, 1);
      }
    },
    closeDialog() {
      this.dialogMenu.show = false;
    },
    opened() {
      this.menusData = [];
      this.$axios.get('/api/monitor/project/child/getChildProjectMenu?id=' + this.dialogMenu.childProjectId).then(res => {
        if (this.menu.length == 0) {
          setTimeout(() => {
            this.menusData = res.data.datas.values;
            this.menusData.forEach(menu => {
              let code = menu.objectId;
              $("#algo" + code).attr("disabled", false);
              $("#algo" + code).val(menu.algorithmId);
              $("#sensor" + code).prop("checked", true)
            });
          }, 1000)
        }

      });
    },
    saveMenus() {
      let other_param = {token: this.token}  // jQuery ajax中serialize()方法增加其他参数

      this.$axios.post('/api/monitor/project/child/saveChildProjectMenu', this.menusData).then(res => {
        if (res.data.status == 200) {
          this.$message({
            showClose: true,
            message: res.data.datas.values,
            type: 'success'
          });
          this.dialogMenu.show = false;
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
      })
    }
  }
}

</script>

<style>

#menu .el-scrollbar__wrap {
  overflow-x: hidden;
}

.menu_pare {
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
}

.menu {
  line-height: 20px;
  font-weight: bold;
}
</style>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/project/menu-select-dialog.vue